if (!customElements.get('crafted-to-last-slider')) {
  class CraftedToLastSlider extends HTMLElement {
    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.crafted-to-last__features',
        pagination: '.crafted-to-last__pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSliderDesktop = this.dataset.enableSlider === 'true';
      this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
      this.items = parseInt(this.dataset.items, 10) || 1;
      this.tabletItems = parseInt(this.dataset.tabletItems, 10) || this.items;
      this.mobileItems = parseInt(this.dataset.mobileItems, 10) || 1;
      this.sliderInstance = false;

      if (!this.sliderWrapper || !this.section) return;
      if (!this.enableSliderDesktop && !this.enableSliderMobile) return;

      this.onBreakpointChange = () => this.init();
      document.addEventListener('matchMobile', this.onBreakpointChange);
      document.addEventListener('unmatchMobile', this.onBreakpointChange);

      if (window.Shopify && Shopify.designMode) {
        this.onBlockSelect = (event) => {
          if (!event.detail || event.detail.sectionId != this.sectionId) return;
          if (!this.sliderInstance || !this.sliderInstance.slider) return;
          const slide = event.target.closest('[data-index]');
          if (!slide || !this.contains(slide)) return;
          const index = Number(slide.dataset.index);
          if (Number.isNaN(index)) return;
          this.sliderInstance.slider.slideTo(index);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.init();
    }

    disconnectedCallback() {
      if (this.onBreakpointChange) {
        document.removeEventListener('matchMobile', this.onBreakpointChange);
        document.removeEventListener('unmatchMobile', this.onBreakpointChange);
      }
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      this.destroySlider();
    }

    init() {
      const isMobile = window.FoxTheme && FoxTheme.config.mqlMobile;
      if (isMobile) {
        if (this.enableSliderMobile) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      } else if (this.enableSliderDesktop) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object') return;
      if (!window.FoxTheme || !FoxTheme.Carousel) return;

      const columnGap = FoxTheme.utils.getGridColumnGap(this.sliderWrapper);
      const nextEl = this.section.querySelector(this.selectors.nextEl);
      const prevEl = this.section.querySelector(this.selectors.prevEl);
      const paginationEl = this.section.querySelector(this.selectors.pagination);
      const showMobilePeek = this.mobileItems <= 1;
      const mobileSlidesPerView = showMobilePeek ? 1.18 : this.mobileItems;
      const mobileSpace = showMobilePeek ? Math.max(columnGap.mobile, 16) : columnGap.mobile;

      const sliderOptions = {
        slidesPerView: mobileSlidesPerView,
        spaceBetween: mobileSpace,
        rewind: true,
        threshold: 2,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems,
            spaceBetween: columnGap.tablet,
          },
          1024: {
            slidesPerView: this.items,
            spaceBetween: columnGap.desktop,
          },
        },
      };

      if (nextEl && prevEl) {
        sliderOptions.navigation = {
          nextEl,
          prevEl,
        };
      }

      if (paginationEl) {
        sliderOptions.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);
      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();
    }

    destroySlider() {
      if (!this.sliderWrapper) return;

      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);

      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }

  customElements.define('crafted-to-last-slider', CraftedToLastSlider);
}
